import axios from "./api";

export const getLanguages = async (callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}languages`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//Simple Encryption and decryption functions

export function encode(str) {
  return str?.replace(/./g, function (c) {
    return ("00" + c.charCodeAt(0)).slice(-3);
  });
}

export function decode(str) {
  return str.replace(/.{3}/g, function (c) {
    return String.fromCharCode(c);
  });
}

export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

//for Images fetching

export const imageUrl = (src) => {
  return process.env.GATSBY_IMAGE_URL + src;
};

export const twoDecimals = (data) => {
  return parseFloat(data).toFixed(2);
};

export const checkIfImageExists = (url, callback) => {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
};

export const numberFormat = (str) => {
  if (str) {
    const twoDecimals = parseFloat(str).toFixed(2);
    return new Intl.NumberFormat("en-US").format(twoDecimals);
  } else {
    return 0;
  }
};

export const removeTags = (data) => {
  var txt = data;
  var rex = /(<([^>]+)>)/gi;
  return txt?.replace(rex, "");
};

export function capitalizeFirstLetter(string) {
  return string
    ?.split(" ")
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(" ");
}
